module.exports = __webpack_public_path__ + "img/map.a8b1d817.png";